import * as React from "react";

import ModuleStatus from "./ModuleStatus";
import UsageKPIs from "./UsageKPIs";
import ManufacturingStats from "./ManufacturingStats";
import BillingStats from "./BillingStats";

import { PERMISSION_NAMES } from "@/lib/auth";
import * as Auth from "@/lib/auth";
import { translate } from "@/modules/shared/IntlProviderWrapper";

import "./Statistics.scss";

type Props = {};

type State = {
    renderStatistics: boolean;
};

class Statistics extends React.Component<Props, State> {
    state: State = {
        renderStatistics: false,
    };

    componentDidUpdate(_prevProps: Props, prevState: State): void {
        if (this.state.renderStatistics && !prevState.renderStatistics) {
            const el = document.querySelector(".grid-main-content");
            el?.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
        }
    }

    handleClickBillingStats = () => {
        this.setState({ renderStatistics: true });
    };

    renderBillingStats() {
        if (!this.state.renderStatistics) {
            return (
                <button
                    type="button"
                    className="btn btn-primary pt-2 pb-2 pl-4 pr-4"
                    onClick={this.handleClickBillingStats}
                >
                    Open billing statistics
                </button>
            );
        } else {
            return <BillingStats />;
        }
    }

    render() {
        return (
            <div className="statistics-page d-flex flex-column gap-5">
                <h1 className="content-title">{translate("Header.menu.statistics", "Statistics")}</h1>
                <ManufacturingStats />
                <UsageKPIs />
                <ModuleStatus />
                {Auth.hasPermission(PERMISSION_NAMES.AdminOnly) && this.renderBillingStats()}
            </div>
        );
    }
}

export default Statistics;
